/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ max: NonNullable<unknown> }} Actionproblemtoolong3Inputs */

const en_actionproblemtoolong3 = /** @type {(inputs: Actionproblemtoolong3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`At most ${i?.max} characters.`)
};

const de_actionproblemtoolong3 = /** @type {(inputs: Actionproblemtoolong3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Höchstens ${i?.max} Zeichen.`)
};

/**
* | output |
* | --- |
* | "At most {max} characters." |
*
* @param {Actionproblemtoolong3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const actionproblemtoolong3 = /** @type {((inputs: Actionproblemtoolong3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Actionproblemtoolong3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_actionproblemtoolong3(inputs)
	return de_actionproblemtoolong3(inputs)
});
export { actionproblemtoolong3 as "actionProblemTooLong" }